const APP_CONFIG = {
  FRONTEND_VERSION: 51,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
